import type { FieldSuggestion, ProcessType } from '@frontend/api';
import type { CascaderPositioningOptions } from '@frontend/components';

import MaterialSelector from 'modules/common/forms/materialSelector/MaterialSelector';
import ProcessMaterialSelector from 'modules/common/forms/materialSelector/ProcessMaterialSelector';
import type { MaterialSelectorChangeHandler } from 'modules/common/forms/materialSelector/types';

type MaterialSelectProps = {
  disabled: boolean;
  menuPortalDestinationRef: React.RefObject<HTMLDivElement>;
  onChange: MaterialSelectorChangeHandler;
  process?: ProcessType | null;
  selectedMaterialId: number | null | string;
  selectedSupplierMaterialId: number | null | string;
  materialFieldSuggestions?: FieldSuggestion[];
  searchModePositioning?: CascaderPositioningOptions;
  menuModePositioning?: CascaderPositioningOptions;
};

const MaterialSelect = ({
  disabled,
  menuPortalDestinationRef,
  onChange,
  process,
  selectedMaterialId,
  selectedSupplierMaterialId,
  materialFieldSuggestions,
  searchModePositioning,
  menuModePositioning,
}: MaterialSelectProps) =>
  !process || process.useGlobalMaterials ? (
    <MaterialSelector
      disabled={disabled}
      materialFieldSuggestions={materialFieldSuggestions}
      materialId={selectedMaterialId}
      onChange={onChange}
      placeholder="Select Material"
      supplierMaterialId={selectedSupplierMaterialId}
      searchModePositioning={searchModePositioning}
      menuModePositioning={menuModePositioning}
    />
  ) : (
    <ProcessMaterialSelector
      disabled={disabled}
      materialFieldSuggestions={materialFieldSuggestions}
      menuPortalDestinationRef={menuPortalDestinationRef}
      onChange={onChange}
      process={process}
      placeholder="Select Material"
      selectedMaterialId={selectedMaterialId}
      selectedSupplierMaterialId={selectedSupplierMaterialId}
    />
  );

export default MaterialSelect;
